import { ildaTabs } from './tabs';

export const tabMap = [
    { id: 1, name: ildaTabs.UNASSIGNED, url: '/ilda/unassigned' },
    { id: 2, name: ildaTabs.TODO, url: '/ilda/to-do' },
    { id: 3, name: ildaTabs.MINE, url: '/ilda/assigned-to-me' },
    { id: 4, name: ildaTabs.ALL, url: '/ilda/all' }
];